export const formatCurrency = (value) => {
  if (value === '0.00' || value === '' || value === 0)
    return (
      <span>
        $ 0
        <span style={{
          fontSize: "0.75em",
          opacity: 0.8,
          position: "relative",
          top: "-2px"
        }}>,00</span>
      </span>
    );

  const formattedValue = Number(value).toFixed(2);
  let [integerPart, decimalPart] = formattedValue.split('.');

  // Formatear con separadores de miles y cambiar el punto decimal por coma
  const formattedInteger = Number(integerPart).toLocaleString('es-CO');

  return (
    <span>
      $ {formattedInteger}
      <span style={{
        fontSize: "0.75em",
        opacity: 0.8,
        position: "relative",

      }}>,{decimalPart}</span>
    </span>
  );
};
